import { BUNDLE_TYPES } from '../constants/packagesConstants';
import { setBundleTypeAction, setPartialDatesAction, setPartialRoomStayAction } from '../ducks/filtersDuck';

const setBundleTypeThunk = (bundleType) => async (dispatch) => {
  dispatch(setBundleTypeAction(bundleType));
  if (bundleType === BUNDLE_TYPES.AIR_CAR) {
    dispatch(setPartialRoomStayAction(false));
    dispatch(setPartialDatesAction({ startDate: null, endDate: null }));
  }
};

export default setBundleTypeThunk;
